var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-card"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }